import SingleAssistantWrapper from "@features/assistants/view/single-assistant-view";

const SingleAssistant = () => {
  return <SingleAssistantWrapper isSidebarCollapsed={false} />;
};

export default SingleAssistant;
